import React from 'react';
import { dayMonth } from './lib/activityFormat';
import { isFeedback } from './lib/documentHistory';

const scoreText = (point) => (point.score == null ? '—' : String(point.score));

const scoreLabel = (point) => (point.score == null ? 'no score' : `score ${point.score}`);

/**
 * An element's points in time order. Feedback points are round toggle
 * buttons (aria-pressed when picked) showing their number, date and moves
 * shown; upload points are inert squares: not focusable and not
 * selectable, since a file carries no move data. Left and Right move focus
 * between the feedback points. `picks` are the picked points' numbers,
 * earlier first; `onPick(number)` is told about a click. Scrolls sideways
 * inside itself when the points do not fit.
 */
const VersionTimeline = ({ points, picks, onPick, label }) => {
  const feedback = points.filter(isFeedback);

  // Only feedback points are buttons, so the group's buttons are exactly them, in order.
  const onKeyDown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const buttons = [...event.currentTarget.querySelectorAll('button')];
    const at = buttons.indexOf(document.activeElement);
    if (at < 0) return;
    const next = event.key === 'ArrowRight' ? Math.min(at + 1, buttons.length - 1) : Math.max(at - 1, 0);
    event.preventDefault();
    buttons[next].focus();
  };

  return (
    <>
      <div className="td-act-vh__timeline" role="group" aria-label={label} onKeyDown={onKeyDown}>
        <div className="td-act-vh__track">
          {points.map((p) => {
            const date = dayMonth(p.at);
            if (!isFeedback(p)) {
              return (
                <div key={p.number} className="td-act-vh__point td-act-vh__point--upload">
                  <span className="td-act-vh__dot" aria-hidden="true">{p.number}</span>
                  <small>{date}</small>
                  <span className="td-act-vh__k">file</span>
                  <span className="td-act-vh__tag">Upload</span>
                  <span className="td-act-sr">{`: version ${p.version_number} uploaded`}</span>
                </div>
              );
            }
            const order = picks.indexOf(p.number);
            const picked = order >= 0;
            let pickClass = '';
            if (picked) pickClass = order === 0 ? ' td-act-vh__point--a' : ' td-act-vh__point--b';
            return (
              <button
                key={p.number}
                type="button"
                className={`td-act-vh__point${pickClass}`}
                aria-pressed={picked}
                aria-label={`Feedback request ${p.number}, ${date}: ${scoreLabel(p)}`}
                onClick={() => onPick(p.number)}
              >
                <span className="td-act-vh__dot">{p.number}</span>
                <small>{date}</small>
                <span className="td-act-vh__k">{scoreText(p)}</span>
                <span className="td-act-vh__tag">Feedback</span>
              </button>
            );
          })}
        </div>
      </div>
      <div className="td-act-vh__key" aria-hidden="true">
        <span><i className="td-act-vh__swatch" />Feedback request</span>
        <span><i className="td-act-vh__swatch td-act-vh__swatch--sq" />Uploaded file</span>
        {feedback.length ? <span>Number under a feedback point = score out of 100</span> : null}
      </div>
    </>
  );
};

export default VersionTimeline;
